import BranchDefaultType from "../types/BranchDefaultType";

export const getBranchSettingsFields = (
  isLoading,
  settingState = BranchDefaultType,
  setSettingState,
  accessLevel
) => {
 
  return [
    {
      type: "text",
      name: "branch_name",
      placeholder: "Name",
      label: "Name",
      autofocus: true,
      required: true,
      disabled: isLoading,
      value: settingState.branch_name,
      setValue: (e) => {
        const value = e.target.value;
        setSettingState({ ...settingState, branch_name: value });
      },
    },
    {
      type: "textarea",
      name: "branch_address",
      placeholder: "Address",
      label: "Address",
      autofocus: false,
      required: true,
      disabled: isLoading,
      value: settingState.branch_address,
      setValue: (e) => {
        const value = e.target.value;
        setSettingState({ ...settingState, branch_address: value });
      },
    },
    {
      type: "phone",
      name: "branch_contactNumber",
      placeholder: "123456789",
      label: "Contact number",
      autofocus: false,
      required: true,
      disabled: isLoading,
      value: settingState.branch_contactNumber,
      setValue: (e) => {
        const value = e.target.value;
        setSettingState({ ...settingState, branch_contactNumber: value });
      },
    },

    {
      type: "phone",
      name: "cust_care_number",
      placeholder: "123456789",
      label: "Customer Care Hotline",
      autofocus: false,
      required: true,
      disabled: isLoading,
      value: settingState.cust_care_number,
      setValue: (e) => {
        const value = e.target.value;
        setSettingState({ ...settingState, cust_care_number: value });
      },
    },
    {
      type: "name",
      name: "fb_messenger",
      placeholder: "FB Messenger",
      label: "FB Messenger",
      autofocus: true,
      required: true,
      disabled: isLoading,
      value: settingState.fb_messenger,
      setValue: (e) => {
        const value = e.target.value;
        setSettingState({ ...settingState, fb_messenger: value });
      },
    },
    {
      type: "text",
      name: "footer_1",
      placeholder: "Footer 1",
      label: "Receipt Footer 1",
      autofocus: true,
      required: true,
      disabled: isLoading,
      value: settingState.footer_1,
      setValue: (e) => {
        const value = e.target.value;
        setSettingState({ ...settingState, footer_1: value });
      },
    },
    {
      type: "text",
      name: "footer_2",
      placeholder: "Footer 2",
      label: "Receipt Footer 2",
      autofocus: true,
      required: true,
      disabled: isLoading,
      value: settingState.footer_2,
      setValue: (e) => {
        const value = e.target.value;
        setSettingState({ ...settingState, footer_2: value });
      },
    },
  

    ...(accessLevel !== 1 || accessLevel !== 2
      ? [
        {
          type: "text",
          name: "sales_date",
          placeholder: "Sales Date",
          label: "Sales Date(YYYY-MM-DD)",
          autofocus: true,
          required: false,
          disabled: isLoading,
          value: settingState.sales_date,
          setValue: (e) => {
            const value = e.target.value;
            setSettingState({ ...settingState, sales_date: value });
          },
        },
        ]
      : []),


  ];
};
